import { FilterTypes } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import { BiohazardousManifest, FilterFields, MainSearchFields } from 'Portals/Customer/entities'
import {
	disposalFacilityNameEntityToLabelValue,
	manifestDocumentNumbersEntityToLabelValue
} from 'Portals/Customer/utils'
import i18n from 'Portals/Customer/utils/i18nService'

export const pickupDateToMobileLabel = 'Pickup Date to:'

export const getMainSearchConfig = (): BiohazardousManifest.Search.Config => ({
	[MainSearchFields.manifestDocument]: {
		label: i18n.t('pages:biohazardousManifest.filters.manifestDocumentLabel'),
		apiFieldName: MainSearchFields.manifestDocument,
		apiSearchFieldName: 'manifestId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.document,
		UrlParamLabel: UrlParamsLabel.manifestDocumentNumber,
		customOptionFormatter: manifestDocumentNumbersEntityToLabelValue
	},
	[MainSearchFields.disposalFacility]: {
		label: i18n.t('pages:biohazardousManifest.filters.disposalFacilityLabel'),
		apiFieldName: MainSearchFields.disposalFacility,
		apiSearchFieldName: 'manifestId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.disposalFacility,
		UrlParamLabel: UrlParamsLabel.disposalFacility,
		customOptionFormatter: disposalFacilityNameEntityToLabelValue
	}
})

export const getFilterConfig = (): BiohazardousManifest.Filter.Config => ({
	[FilterFields.pickupDateFrom]: {
		label: i18n.t('pages:biohazardousManifest.filters.pickupDateFromLabel'),
		apiFilterFieldName: 'pickupDateFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[FilterFields.pickupDateTo]: {
		label: i18n.t('pages:biohazardousManifest.filters.pickupDateToLabel'),
		apiFilterFieldName: 'pickupDateTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[FilterFields.serviceSite]: {
		label: i18n.t('pages:biohazardousManifest.filters.serviceSiteLabel'),
		apiFilterFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	}
})
